import React from "react";
import Authenticated from "@/Layouts/Authenticated";
import PageHeading from "@/Components/PageHeading";
import { usePage } from "@inertiajs/inertia-react";

const breadcrumb = [{ name: "Dashboard", route: route("dashboard") }];

const Home = () => {
    const { studentsCount, uncollectedFee, studentsCountFee } = usePage().props;

    return (
        <div className="py-6">
            <PageHeading heading={"Dashboard"} breadcrumb={breadcrumb} />
            <div className="mt-8">
                <div className="mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-xl font-medium leading-6 text-gray-900">
                        Overview
                    </h2>
                    <dl className="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                        <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                            <dt className="truncate text-sm font-medium text-gray-500">
                                Total Students
                            </dt>
                            <dd className="mt-1 text-3xl font-semibold text-gray-900">
                                {studentsCount}
                            </dd>
                        </div>
                        <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                            <dt className="truncate text-sm font-medium text-gray-500">
                                Uncollected Fee Amount
                            </dt>
                            <dd className="mt-1 text-3xl font-semibold text-gray-900">
                                {new Intl.NumberFormat("en-IN", {
                                    style: "currency",
                                    currency: "NPR",
                                    currencyDisplay: "narrowSymbol",
                                }).format(uncollectedFee)}
                            </dd>
                        </div>
                        <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                            <dt className="truncate text-sm font-medium text-gray-500">
                                Total Students with balance > 10000
                            </dt>
                            <dd className="mt-1 text-3xl font-semibold text-gray-900">
                                {studentsCountFee}
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    );
};

Home.layout = (page) => <Authenticated title={"Dashboard"} children={page} />;

export default Home;
